var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomAlert',{attrs:{"show-alert":_vm.submitError,"alert-type":"error"}},[_c('span',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.submitErrorMsg))])]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"footer-props":{
      'items-per-page-text': 'Datensätze pro Seite',
      'items-per-page-all-text': 'Alle',
      'page-text': '{0}-{1} von {2}'
    },"headers":_vm.headers,"items":_vm.items,"items-per-page":10,"height":500},scopedSlots:_vm._u([{key:"item.leadRegion",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.leadRegion)}})]}},{key:"item.documents",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.documents)}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }